export default __webpack_public_path__ + "static/media/canopy.3e05407d.svg";